import { Scope } from '../../../../environments/environment.interfaces';

export const BASKET_SCOPE_DEV: Scope = {
    api: 'BASKET',
    scopes: [
        'openid',
        'https://login.sew-d.com/04e4f1ac-64b7-4d47-ae20-91ff9be58b13/Basket.Read',
        'offline_access',
    ],
};

export const WISHLIST_SCOPE_DEV: Scope = {
    api: 'WISHLIST',
    scopes: [
        'openid',
        'https://login.sew-d.com/628a6c23-ed6f-4dd5-816e-1bf6f8e0d5c2/WishList.Read',
        'offline_access',
    ],
};

export const WZ_SCOPE_DEV: Scope = {
    api: 'WZ',
    scopes: [
        'openid',
        'https://login.sew-d.com/c636b7c3-d751-4420-ba67-cba921820da0/FullAccess',
        'offline_access',
    ],
};
